import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';
import { RemoteAssistanceStrService } from './remote-assistance-str.service';
import { RemoteAssistanceComponent } from './remote-assistance.component';
import { RemoteAssistanceService } from './remote-assistance.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
    ],
    declarations: [RemoteAssistanceComponent],
    providers: [
        RemoteAssistanceService,
        RemoteAssistanceStrService,
    ],
    exports: [RemoteAssistanceComponent],
})
export class RemoteAssistanceModule {}
